// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"4e05163fe3744cace1e0","873":"013f9aa79f5064863a14"}[chunkId] + ".js";
};